// 9fbef606107a605d69c0edbcd8029e5d
const yellow = {
  500: '#ffe700',
  600: '#f6d343',
  700: '#f79e1b',
  800: '#ff8e15',
  900: '#fbe64d',
  1000: '#FCEB71',
};
export default yellow;
